var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var requestConfig = require("./requestConfig");

var defaultEnv = requestConfig.defaultEnv;

var request = require('./requestGenerator');

var util = require("./util");

var offlineSerialize = require('./offlineSerialization');

var _require$TierError = require("@oneledger/middle_utility").TierError,
    ErrorType = _require$TierError.ErrorType,
    ErrorUtil = _require$TierError.ErrorUtil;

var requestErrors = ErrorType.requestErrors;
console.warn("Warning: requestOffline module will be renamed to 'ONS' in future version, please use sdk.ONS to access all domain txs");
/**
 * @description Offline rawTx generator of creating domain
 * @param parameters {Object} object of parameters
 * @param parameters.ownerAddress {string} domain owner address
 * @param parameters.beneficiaryAccount {string} domain associated address
 * @param parameters.domainName {string} domain name
 * @param parameters.price {Object} domain creation price object
 * @param parameters.price.currency {string} name of the currency that used to create domain
 * @param parameters.price.value {string} amount of currency that used to create domain
 * @param [parameters.uri] {string} domain uri
 * @param [parameters.gasAdjustment] {number} tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<response|error>} Promise.reject: error object , Promise.resolve: response object has rawTx with tx fee estimation
 */

function domainCreateTxOffline(_x) {
  return _domainCreateTxOffline.apply(this, arguments);
}
/**
 * @description Offline rawTx generator of updating domain
 * @param parameters {Object} object of parameters
 * @param parameters.ownerAddress {string} domain owner address
 * @param parameters.beneficiaryAccount {string} updated domain associated account address
 * @param parameters.domainName {string} domain name
 * @param parameters.active {boolean} updated domain active flag
 * @param [parameters.uri] {string} domain uri
 * @param [parameters.gasAdjustment] {number} tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<response|error>} Promise.reject: error object , Promise.resolve: response object has rawTx with tx fee estimation
 */


function _domainCreateTxOffline() {
  _domainCreateTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var ownerAddress,
        beneficiaryAccount,
        domainName,
        price,
        uri,
        _ref$gasAdjustment,
        gasAdjustment,
        env,
        checkPriceValueResult,
        gasPrice,
        result,
        storeConfig,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ownerAddress = _ref.ownerAddress, beneficiaryAccount = _ref.beneficiaryAccount, domainName = _ref.domainName, price = _ref.price, uri = _ref.uri, _ref$gasAdjustment = _ref.gasAdjustment, gasAdjustment = _ref$gasAdjustment === void 0 ? 0 : _ref$gasAdjustment;
            env = _args.length > 1 && _args[1] !== undefined ? _args[1] : defaultEnv;

            if (util.isValidOLTAddress(ownerAddress)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 4:
            checkPriceValueResult = util.requestPriceConverter(price.value, requestConfig.OLT.decimal);

            if (checkPriceValueResult) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalPrice)));

          case 7:
            price.value = checkPriceValueResult;
            _context.prev = 8;
            _context.next = 11;
            return request.queryGasPrice(env);

          case 11:
            result = _context.sent;
            gasPrice = result.response;
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](8);
            return _context.abrupt("return", Promise.reject(_context.t0));

          case 18:
            // check if domain name is valid
            storeConfig = env.storeConfig;
            _context.next = 21;
            return util.validateDomainName(domainName, storeConfig).catch(function (err) {
              var returnErr = {
                code: requestErrors.IllegalDomainName.code,
                message: requestErrors.IllegalDomainName.message,
                detail: "".concat(err)
              };
              return Promise.reject(ErrorUtil.errorWrap(returnErr));
            });

          case 21:
            _context.next = 23;
            return util.verifyBeneficiaryAccount(beneficiaryAccount, domainName).catch(function (error) {
              return Promise.reject(error);
            });

          case 23:
            if (!(!util.isEmpty(uri) && !util.isValidUri(uri))) {
              _context.next = 25;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidURI)));

          case 25:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context.next = 27;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 27:
            tx_dataObj = {
              owner: ownerAddress,
              account: beneficiaryAccount,
              name: util.lowerCaseDomainName(domainName),
              buyingPrice: price,
              uri: uri
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.DOMAIN_CREATE, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context.next = 32;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 32:
            feeEstimationResult = _context.sent;
            return _context.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[8, 15]]);
  }));
  return _domainCreateTxOffline.apply(this, arguments);
}

function domainUpdateTxOffline(_x2) {
  return _domainUpdateTxOffline.apply(this, arguments);
}
/**
 * @description Offline rawTx generator of renewing domain
 * Only parent domain can be renewed
 * @param parameters {Object} object of parameters
 * @param parameters.ownerAddress {string} domain owner address
 * @param parameters.domainName {string} domain name
 * @param parameters.price {Object} domain creation price object
 * @param parameters.price.currency {string} name of the currency that used to create domain
 * @param parameters.price.value {string} amount of currency that used to create domain
 * @param [parameters.gasAdjustment] {number} tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<response|error>} Promise.reject: error object , Promise.resolve: response object has rawTx with tx fee estimation
 */


function _domainUpdateTxOffline() {
  _domainUpdateTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(_ref2) {
    var ownerAddress,
        beneficiaryAccount,
        domainName,
        active,
        uri,
        _ref2$gasAdjustment,
        gasAdjustment,
        env,
        gasPrice,
        result,
        storeConfig,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            ownerAddress = _ref2.ownerAddress, beneficiaryAccount = _ref2.beneficiaryAccount, domainName = _ref2.domainName, active = _ref2.active, uri = _ref2.uri, _ref2$gasAdjustment = _ref2.gasAdjustment, gasAdjustment = _ref2$gasAdjustment === void 0 ? 0 : _ref2$gasAdjustment;
            env = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : defaultEnv;

            if (util.isValidOLTAddress(ownerAddress)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 4:
            _context2.next = 6;
            return util.domainActiveFlagChecker(active).catch(function (error) {
              return Promise.reject(error);
            });

          case 6:
            _context2.prev = 6;
            _context2.next = 9;
            return request.queryGasPrice(env);

          case 9:
            result = _context2.sent;
            gasPrice = result.response;
            _context2.next = 16;
            break;

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](6);
            return _context2.abrupt("return", Promise.reject(_context2.t0));

          case 16:
            // check if domain name is valid
            storeConfig = env.storeConfig;
            _context2.next = 19;
            return util.validateDomainName(domainName, storeConfig).catch(function (err) {
              var returnErr = {
                code: requestErrors.IllegalDomainName.code,
                message: requestErrors.IllegalDomainName.message,
                detail: "".concat(err)
              };
              return Promise.reject(ErrorUtil.errorWrap(returnErr));
            });

          case 19:
            _context2.next = 21;
            return util.verifyBeneficiaryAccount(beneficiaryAccount, domainName).catch(function (error) {
              return Promise.reject(error);
            });

          case 21:
            if (!(!util.isEmpty(uri) && !util.isValidUri(uri))) {
              _context2.next = 23;
              break;
            }

            return _context2.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidURI)));

          case 23:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context2.next = 25;
              break;
            }

            return _context2.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 25:
            tx_dataObj = {
              owner: ownerAddress,
              beneficiary: beneficiaryAccount,
              name: util.lowerCaseDomainName(domainName),
              active: active,
              uri: uri
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.DOMAIN_UPDATE, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context2.next = 30;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 30:
            feeEstimationResult = _context2.sent;
            return _context2.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 32:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[6, 13]]);
  }));
  return _domainUpdateTxOffline.apply(this, arguments);
}

function domainRenewTxOffline(_x3) {
  return _domainRenewTxOffline.apply(this, arguments);
}
/**
 * @description Offline rawTx generator of updating a domain onSale flag
 * Only parent domain can be put on sale
 * @param parameters {Object} object of parameters
 * @param parameters.domainName {string} domain name
 * @param parameters.ownerAddress {string} domain owner address
 * @param parameters.price {Object} price for selling a domain
 * @param parameters.price.currency {string} name of the currency that put domain on sale
 * @param parameters.price.value {string} amount of currency that put domain on sale
 * @param parameters.cancelSale {boolean} updated domain onSale flag
 * @param [parameters.gasAdjustment] {number} tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<response|error>} Promise.reject: error object , Promise.resolve: response object has rawTx with tx fee estimation
 */


function _domainRenewTxOffline() {
  _domainRenewTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(_ref3) {
    var ownerAddress,
        domainName,
        price,
        _ref3$gasAdjustment,
        gasAdjustment,
        env,
        checkPriceValueResult,
        gasPrice,
        result,
        storeConfig,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            ownerAddress = _ref3.ownerAddress, domainName = _ref3.domainName, price = _ref3.price, _ref3$gasAdjustment = _ref3.gasAdjustment, gasAdjustment = _ref3$gasAdjustment === void 0 ? 0 : _ref3$gasAdjustment;
            env = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : defaultEnv;

            if (util.isValidOLTAddress(ownerAddress)) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 4:
            checkPriceValueResult = util.requestPriceConverter(price.value, requestConfig.OLT.decimal);

            if (checkPriceValueResult) {
              _context3.next = 7;
              break;
            }

            return _context3.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalPrice)));

          case 7:
            price.value = checkPriceValueResult;
            _context3.prev = 8;
            _context3.next = 11;
            return request.queryGasPrice(env);

          case 11:
            result = _context3.sent;
            gasPrice = result.response;
            _context3.next = 18;
            break;

          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](8);
            return _context3.abrupt("return", Promise.reject(_context3.t0));

          case 18:
            // check if domain name is valid
            storeConfig = env.storeConfig;
            _context3.next = 21;
            return util.validateDomainName(domainName, storeConfig).catch(function (err) {
              var returnErr = {
                code: requestErrors.IllegalDomainName.code,
                message: requestErrors.IllegalDomainName.message,
                detail: "".concat(err)
              };
              return Promise.reject(ErrorUtil.errorWrap(returnErr));
            });

          case 21:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context3.next = 23;
              break;
            }

            return _context3.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 23:
            tx_dataObj = {
              owner: ownerAddress,
              name: util.lowerCaseDomainName(domainName),
              buyingPrice: price
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.DOMAIN_RENEW, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context3.next = 28;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 28:
            feeEstimationResult = _context3.sent;
            return _context3.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 30:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[8, 15]]);
  }));
  return _domainRenewTxOffline.apply(this, arguments);
}

function domainSaleTxOffline(_x4) {
  return _domainSaleTxOffline.apply(this, arguments);
}
/**
 * @description Offline rawTx generator of buying a domain
 * Only parent domain can be purchased
 * @param parameters {Object} object of parameters
 * @param parameters.domainName {string} domain name
 * @param parameters.buyerAddress {string} buyer's address
 * @param parameters.beneficiaryAccount {string} new domain associated account address
 * @param parameters.offerAmount {Object} purchase offer object
 * @param parameters.offerAmount.currency {string} name of the currency that used to buy domain
 * @param parameters.offerAmount.value {string} amount of currency that used to buy domain
 * @param [parameters.gasAdjustment] {number} tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<response|error>} Promise.reject: error object , Promise.resolve: response object has rawTx with tx fee estimation
 */


function _domainSaleTxOffline() {
  _domainSaleTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(_ref4) {
    var domainName,
        ownerAddress,
        price,
        cancelSale,
        _ref4$gasAdjustment,
        gasAdjustment,
        env,
        checkPriceValueResult,
        gasPrice,
        result,
        storeConfig,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args4 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            domainName = _ref4.domainName, ownerAddress = _ref4.ownerAddress, price = _ref4.price, cancelSale = _ref4.cancelSale, _ref4$gasAdjustment = _ref4.gasAdjustment, gasAdjustment = _ref4$gasAdjustment === void 0 ? 0 : _ref4$gasAdjustment;
            env = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : defaultEnv;

            if (util.isValidOLTAddress(ownerAddress)) {
              _context4.next = 4;
              break;
            }

            return _context4.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 4:
            _context4.next = 6;
            return util.domainCancelSaleFlagChecker(cancelSale).catch(function (error) {
              return Promise.reject(error);
            });

          case 6:
            // price convert
            checkPriceValueResult = util.requestPriceConverter(price.value, requestConfig.OLT.decimal);

            if (checkPriceValueResult) {
              _context4.next = 9;
              break;
            }

            return _context4.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalPrice)));

          case 9:
            price.value = checkPriceValueResult;
            _context4.prev = 10;
            _context4.next = 13;
            return request.queryGasPrice(env);

          case 13:
            result = _context4.sent;
            gasPrice = result.response;
            _context4.next = 20;
            break;

          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](10);
            return _context4.abrupt("return", Promise.reject(_context4.t0));

          case 20:
            // check if domain name is valid
            storeConfig = env.storeConfig;
            _context4.next = 23;
            return util.validateDomainName(domainName, storeConfig).catch(function (err) {
              var returnErr = {
                code: requestErrors.IllegalDomainName.code,
                message: requestErrors.IllegalDomainName.message,
                detail: "".concat(err)
              };
              return Promise.reject(ErrorUtil.errorWrap(returnErr));
            });

          case 23:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context4.next = 25;
              break;
            }

            return _context4.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 25:
            tx_dataObj = {
              name: util.lowerCaseDomainName(domainName),
              ownerAddress: ownerAddress,
              price: price,
              cancelSale: cancelSale
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.DOMAIN_SELL, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context4.next = 30;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 30:
            feeEstimationResult = _context4.sent;
            return _context4.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 32:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[10, 17]]);
  }));
  return _domainSaleTxOffline.apply(this, arguments);
}

function domainPurchaseTxOffline(_x5) {
  return _domainPurchaseTxOffline.apply(this, arguments);
}
/**
 * @description Offline RawTx generator of Sending registered currency to OLT address
 * @param parameters {Object} object of parameters
 * @param parameters.fromAddr {string} sender address
 * @param parameters.to {string} recipient address
 * @param parameters.amount {Object} sending amount object
 * @param parameters.amount.currency {string} sending currency name
 * @param parameters.amount.value {string} sending amount
 * @param [parameters.gasAdjustment] {number} tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<response|error>} Promise.reject: error object , Promise.resolve: response object has rawTx with tx fee estimation
 */


function _domainPurchaseTxOffline() {
  _domainPurchaseTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(_ref5) {
    var domainName,
        buyerAddress,
        beneficiaryAccount,
        offerAmount,
        _ref5$gasAdjustment,
        gasAdjustment,
        env,
        checkOfferValueResult,
        gasPrice,
        result,
        storeConfig,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args5 = arguments;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            domainName = _ref5.domainName, buyerAddress = _ref5.buyerAddress, beneficiaryAccount = _ref5.beneficiaryAccount, offerAmount = _ref5.offerAmount, _ref5$gasAdjustment = _ref5.gasAdjustment, gasAdjustment = _ref5$gasAdjustment === void 0 ? 0 : _ref5$gasAdjustment;
            env = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : defaultEnv;

            if (util.isValidOLTAddress(buyerAddress)) {
              _context5.next = 4;
              break;
            }

            return _context5.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 4:
            // offer amount convert
            checkOfferValueResult = util.requestPriceConverter(offerAmount.value, requestConfig.OLT.decimal);

            if (checkOfferValueResult) {
              _context5.next = 7;
              break;
            }

            return _context5.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalOfferAmount)));

          case 7:
            offerAmount.value = checkOfferValueResult;
            _context5.prev = 8;
            _context5.next = 11;
            return request.queryGasPrice(env);

          case 11:
            result = _context5.sent;
            gasPrice = result.response;
            _context5.next = 18;
            break;

          case 15:
            _context5.prev = 15;
            _context5.t0 = _context5["catch"](8);
            return _context5.abrupt("return", Promise.reject(_context5.t0));

          case 18:
            // check if domain name is valid
            storeConfig = env.storeConfig;
            _context5.next = 21;
            return util.validateDomainName(domainName, storeConfig).catch(function (err) {
              var returnErr = {
                code: requestErrors.IllegalDomainName.code,
                message: requestErrors.IllegalDomainName.message,
                detail: "".concat(err)
              };
              return Promise.reject(ErrorUtil.errorWrap(returnErr));
            });

          case 21:
            _context5.next = 23;
            return util.verifyBeneficiaryAccount(beneficiaryAccount, domainName).catch(function (error) {
              return Promise.reject(error);
            });

          case 23:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context5.next = 25;
              break;
            }

            return _context5.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 25:
            tx_dataObj = {
              name: util.lowerCaseDomainName(domainName),
              buyer: buyerAddress,
              account: beneficiaryAccount,
              offering: offerAmount
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.DOMAIN_PURCHASE, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context5.next = 30;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 30:
            feeEstimationResult = _context5.sent;
            return _context5.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 32:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this, [[8, 15]]);
  }));
  return _domainPurchaseTxOffline.apply(this, arguments);
}

function sendToAddressTxOffline(_x6) {
  return _sendToAddressTxOffline.apply(this, arguments);
}
/**
 * @description Offline rawTx generator of sending currency to a domain
 * @param parameters {Object} object of parameters
 * @param parameters.domainName {string} domain name
 * @param parameters.fromAccount {string} sender address
 * @param parameters.amount {Object} sending amount object
 * @param parameters.amount.currency {string} name of the currency that send
 * @param parameters.amount.value {string} amount of currency that send
 * @param [parameters.gasAdjustment] {number} tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<response|error>} Promise.reject: error object , Promise.resolve: response object has rawTx with tx fee estimation
 */


function _sendToAddressTxOffline() {
  _sendToAddressTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(_ref6) {
    var fromAddr,
        to,
        amount,
        _ref6$gasAdjustment,
        gasAdjustment,
        env,
        sendingCurrency,
        checkAmountValueResult,
        gasPrice,
        result,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args6 = arguments;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            fromAddr = _ref6.fromAddr, to = _ref6.to, amount = _ref6.amount, _ref6$gasAdjustment = _ref6.gasAdjustment, gasAdjustment = _ref6$gasAdjustment === void 0 ? 0 : _ref6$gasAdjustment;
            env = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : defaultEnv;

            if (!(!util.isValidOLTAddress(fromAddr) || !util.isValidOLTAddress(to))) {
              _context6.next = 4;
              break;
            }

            return _context6.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 4:
            _context6.next = 6;
            return util.getCurrency(amount.currency).catch(function (err) {
              return Promise.reject(err);
            });

          case 6:
            sendingCurrency = _context6.sent;
            checkAmountValueResult = util.requestPriceConverter(amount.value, sendingCurrency.decimal);

            if (checkAmountValueResult) {
              _context6.next = 10;
              break;
            }

            return _context6.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalAmount)));

          case 10:
            amount.value = checkAmountValueResult;
            _context6.prev = 11;
            _context6.next = 14;
            return request.queryGasPrice(env);

          case 14:
            result = _context6.sent;
            gasPrice = result.response;
            _context6.next = 21;
            break;

          case 18:
            _context6.prev = 18;
            _context6.t0 = _context6["catch"](11);
            return _context6.abrupt("return", Promise.reject(_context6.t0));

          case 21:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context6.next = 23;
              break;
            }

            return _context6.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 23:
            tx_dataObj = {
              from: fromAddr,
              to: to,
              amount: amount
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.SEND, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context6.next = 28;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 28:
            feeEstimationResult = _context6.sent;
            return _context6.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 30:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this, [[11, 18]]);
  }));
  return _sendToAddressTxOffline.apply(this, arguments);
}

function sendToDomainTxOffline(_x7) {
  return _sendToDomainTxOffline.apply(this, arguments);
}
/**
 * @description Offline rawTx generator of deleting subdomains of given domain
 * @param parameters {Object} object of parameters
 * @param parameters.domainName {string} domain name
 * @param parameters.ownerAddress {string} domain owner address
 * @param [parameters.gasAdjustment] {number} tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<response|error>} Promise.reject: error object , Promise.resolve: response object has rawTx with tx fee estimation
 */


function _sendToDomainTxOffline() {
  _sendToDomainTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7(_ref7) {
    var domainName,
        fromAccount,
        amount,
        _ref7$gasAdjustment,
        gasAdjustment,
        env,
        sendingCurrency,
        checkAmountValueResult,
        gasPrice,
        result,
        storeConfig,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args7 = arguments;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            domainName = _ref7.domainName, fromAccount = _ref7.fromAccount, amount = _ref7.amount, _ref7$gasAdjustment = _ref7.gasAdjustment, gasAdjustment = _ref7$gasAdjustment === void 0 ? 0 : _ref7$gasAdjustment;
            env = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : defaultEnv;

            if (util.isValidOLTAddress(fromAccount)) {
              _context7.next = 4;
              break;
            }

            return _context7.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 4:
            _context7.next = 6;
            return util.getCurrency(amount.currency).catch(function (err) {
              return Promise.reject(err);
            });

          case 6:
            sendingCurrency = _context7.sent;
            checkAmountValueResult = util.requestPriceConverter(amount.value, sendingCurrency.decimal);

            if (checkAmountValueResult) {
              _context7.next = 10;
              break;
            }

            return _context7.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalAmount)));

          case 10:
            amount.value = checkAmountValueResult;
            _context7.prev = 11;
            _context7.next = 14;
            return request.queryGasPrice(env);

          case 14:
            result = _context7.sent;
            gasPrice = result.response;
            _context7.next = 21;
            break;

          case 18:
            _context7.prev = 18;
            _context7.t0 = _context7["catch"](11);
            return _context7.abrupt("return", Promise.reject(_context7.t0));

          case 21:
            // check if domain name is valid
            storeConfig = env.storeConfig;
            _context7.next = 24;
            return util.validateDomainName(domainName, storeConfig).catch(function (err) {
              var returnErr = {
                code: requestErrors.IllegalDomainName.code,
                message: requestErrors.IllegalDomainName.message,
                detail: "".concat(err)
              };
              return Promise.reject(ErrorUtil.errorWrap(returnErr));
            });

          case 24:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context7.next = 26;
              break;
            }

            return _context7.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 26:
            tx_dataObj = {
              name: util.lowerCaseDomainName(domainName),
              from: fromAccount,
              amount: amount
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.DOMAIN_SEND, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context7.next = 31;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 31:
            feeEstimationResult = _context7.sent;
            return _context7.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 33:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this, [[11, 18]]);
  }));
  return _sendToDomainTxOffline.apply(this, arguments);
}

function domainDeleteSubTxOffline(_x8) {
  return _domainDeleteSubTxOffline.apply(this, arguments);
}

function _domainDeleteSubTxOffline() {
  _domainDeleteSubTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8(_ref8) {
    var domainName,
        ownerAddress,
        _ref8$gasAdjustment,
        gasAdjustment,
        env,
        gasPrice,
        result,
        storeConfig,
        tx_dataObj,
        assembledTx,
        gas,
        feeEstimationResult,
        _args8 = arguments;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            domainName = _ref8.domainName, ownerAddress = _ref8.ownerAddress, _ref8$gasAdjustment = _ref8.gasAdjustment, gasAdjustment = _ref8$gasAdjustment === void 0 ? 0 : _ref8$gasAdjustment;
            env = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : defaultEnv;

            if (util.isValidOLTAddress(ownerAddress)) {
              _context8.next = 4;
              break;
            }

            return _context8.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 4:
            _context8.prev = 4;
            _context8.next = 7;
            return request.queryGasPrice(env);

          case 7:
            result = _context8.sent;
            gasPrice = result.response;
            _context8.next = 14;
            break;

          case 11:
            _context8.prev = 11;
            _context8.t0 = _context8["catch"](4);
            return _context8.abrupt("return", Promise.reject(_context8.t0));

          case 14:
            // check if domain name is valid
            storeConfig = env.storeConfig;
            _context8.next = 17;
            return util.validateDomainName(domainName, storeConfig).catch(function (err) {
              var returnErr = {
                code: requestErrors.IllegalDomainName.code,
                message: requestErrors.IllegalDomainName.message,
                detail: "".concat(err)
              };
              return Promise.reject(ErrorUtil.errorWrap(returnErr));
            });

          case 17:
            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context8.next = 19;
              break;
            }

            return _context8.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 19:
            tx_dataObj = {
              owner: ownerAddress,
              name: util.lowerCaseDomainName(domainName)
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.DOMAIN_DELETE_SUB, tx_dataObj, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context8.next = 24;
            return util.txFeeEstimator(gas, gasPrice).catch(function (err) {
              return Promise.reject(err);
            });

          case 24:
            feeEstimationResult = _context8.sent;
            return _context8.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx)), {
              feeEstimation: feeEstimationResult.response
            }))));

          case 26:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this, [[4, 11]]);
  }));
  return _domainDeleteSubTxOffline.apply(this, arguments);
}

module.exports = {
  domainCreateTxOffline: domainCreateTxOffline,
  domainUpdateTxOffline: domainUpdateTxOffline,
  domainRenewTxOffline: domainRenewTxOffline,
  domainSaleTxOffline: domainSaleTxOffline,
  domainPurchaseTxOffline: domainPurchaseTxOffline,
  sendToAddressTxOffline: sendToAddressTxOffline,
  sendToDomainTxOffline: sendToDomainTxOffline,
  domainDeleteSubTxOffline: domainDeleteSubTxOffline
};